import { render, staticRenderFns } from "./paymentError.vue?vue&type=template&id=5a3ab314&scoped=true"
import script from "./paymentError.vue?vue&type=script&lang=js"
export * from "./paymentError.vue?vue&type=script&lang=js"
import style0 from "./paymentError.vue?vue&type=style&index=0&id=5a3ab314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3ab314",
  null
  
)

export default component.exports